module.exports = {"top":"Top :item","item":":item","errors":{"noItemFound":":item no encontrado","nothingFound":"¡Nada encontrado!"}};